<template>
    <el-card>
        <el-row>
            <el-col class="news-title-top">
            <img src="../assets/images/zyb.png" alt="高考资讯" class="zyb-img">
            热门资讯
            </el-col>
        </el-row>
        <el-row class="news-box">
            <div v-if="newsStatus == '1'">
                <el-col v-for="index1 in 10" :key="index1">
                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="35" width="300">
                        <rect x="0" y="15" width="200" height="25" />
                    </ContentLoader>
                </el-col>
            </div>
            <div class="no-data-box" v-else-if="newsStatus == '2'">
                <img src="../assets/images/null.png" alt="没有数据">
                <p>暂无数据</p>
            </div>
            <el-row v-else-if="newsStatus == '3'">
                <el-row class="news-list">
                    <div class="news-title" v-for="(item,index) in newsList" :key="index" @click="goDetailHandler(item.id)">{{item.news_title}}</div>
                </el-row>
            </el-row>
        </el-row>
    </el-card>
</template>

<script>
import { schoolNews } from '@/api/home'
import { ContentLoader } from 'vue-content-loader'
import { mapState } from 'vuex'

export default {
    components: {
        ContentLoader
    },
    name: "News",
    data(){
        return {
            newsList: [],
            newsStatus: '1'
        }
    },
    filters: {
        formatDate: function(time) {
        time = time * 1000
        let date = new Date(time);
        let YY = date.getFullYear();
        let MM = date.getMonth() + 1;
        let DD = date.getDate();
        return YY + '.' + MM + '.' + DD;
        }
    },
    created() {
        this.schoolNewsHandler();
    },
    computed: {
    ...mapState({
        token: state => state.user.token,
        }),
    },
    watch: {
        token (newVal) {
        if(newVal != '') {
            this.schoolNewsHandler();
        }
        }
    },
    methods: {
        schoolNewsHandler() {
            schoolNews().then(res => {
                if(res.data.length == 0) {
                    this.newsStatus = '2';
                    return
                }
                this.newsStatus = '3';
                // const newsList = res.data.map(item => {
                //     if(!item.banner_url) {
                //         let index = Math.random();
                //         index = index * 10;
                //         index = Math.ceil(index); 
                //         item.banner_url = require('../assets/images/news'+ index + '.png');
                //     } else {
                //         item.banner_url = 'https://gaokao.zmpajx.com/' + item.banner_url;
                //     }
                //     return item;
                // })
                this.newsList = res.data;
            })
        },
        goDetailHandler(id) {
            this.$router.push({
                        path:'/newsDetail',
                query: {
                    id: id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .news-title-top {
        text-align: left;
    }
    .zyb-img {
        width: 24px;
        height: 24px;
        position: relative;
        top: 4px;
    }
    .el-col {
        color: #2c2e33;
        font-size: 24px;
        font-weight: 600;
    }
    .news-box {
        border-top: 1px solid #f0f2f5;
        margin-top: 14px;
        position: relative;
        .news-list {
            cursor: pointer;
            position: relative;
            .news-title {
                margin-top: 27px;
                cursor: pointer;
                @include gnowrap;
                text-align: left;
            }
            .news-title:hover {
                color: $common-color;
            }
        }
    }
    .no-data-box {
        position: relative;
        top: 95px;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
            margin-left: -14px;
        }
    }
</style>